module.exports = __webpack_public_path__ + "static/009-6d0c841aa5d2fc6419e059509639a0e3.jpg";